import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import RepositoryDirective from '../../../smoothr-web-app-core/directives/repository-directive';
import { MenuPage } from '../menu/menu.page';
import { OrderTypeSelection } from '../../components/order-type-selection/order-type-selection.component';
import { PreorderType } from 'src/smoothr-web-app-core/enums/PreorderType';
import { environment } from 'src/environments/environment';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import Address from 'src/smoothr-web-app-core/models/Address';
import { OrderType } from 'src/smoothr-web-app-core/enums/OrderType';

@Component({
  selector: 'app-order-setup',
  templateUrl: './order-setup.page.html',
  styleUrls: ['./order-setup.page.scss'],
})
export class OrderSetupPage extends RepositoryDirective implements OnInit {
  static url = 'order-setup';
  
  loading = false;

  constructor(
    protected repository: RepositoryService,
    private router: Router
  ) {
    super(repository);
  }

  static async navigate(router: Router) {
    await router.navigateByUrl(OrderSetupPage.url);
  }

  ngOnInit() {
    super.ngOnInit();
    
  }

  onOrderTypeSelected(orderType: OrderTypeSelection) {
    this.loading = true;
    console.log(orderType);
    this.locateAndShowStores(PreorderType.INSIDE, orderType);
    // Store the selected order type in the repository/order
    if (this.order) {
      // Use statusNote field to store the order type information
      this.order.statusNote = `Order Type: ${orderType.name}`;
      this.repository.onOrderChange(this.order);
    }
  
  }

  async navigateToMenu() {
    // this.loading = true;
    await MenuPage.navigate(this.router);
    this.loading = false;
  }

  onBackToHome() {
    this.router.navigate(['/home']);
  }

  async locateAndShowStores(preorderType: PreorderType = PreorderType.INSIDE, orderType: OrderTypeSelection) {
     const reishauerVenue = await this.repository.getAllVenues(environment.customerGroup);
     console.log('Available venues:', reishauerVenue);

     const currentVenue = reishauerVenue.find((res) => res.readableId === orderType.readableId);

     if (!currentVenue) {
       console.error('Venue not found with readableId:', orderType.readableId);
       console.log('Available venue IDs:', reishauerVenue.map(v => v.readableId));
       this.loading = false;
       return;
     }

     await this.loadVenueAndCreateOrder(currentVenue, null, preorderType);
  }


  async loadVenueAndCreateOrder(venue: Venue, address: Address, preorderType: PreorderType) {
     if (!venue || !venue._id) {
       console.error('Invalid venue provided:', venue);
       this.loading = false;
       return;
     }

     const loadedVenue = await this.repository.getVenue(venue._id);
     this.repository.createOrder(loadedVenue, address, OrderType.PREORDER, preorderType);
      if(loadedVenue) {
        this.navigateToMenu();
     }
  }

}